<script setup>
import WootLabel from 'dashboard/components-next/label/Label.vue';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';

defineProps({
  backfillPreview: { type: Object, default: null },
  cutoverPreview: { type: Object, default: null },
});

const { formatStatus, labelColor } = useAutomationOperationsFormatters();
</script>

<template>
  <div class="mb-3 grid gap-3 lg:grid-cols-2">
    <div
      v-if="backfillPreview"
      class="min-w-0 border border-n-weak bg-n-surface-1 p-3"
      data-test="cadence-backfill-preview"
    >
      <div class="mb-2 flex flex-wrap items-center gap-2">
        <span class="text-label-large text-n-slate-12">
          {{ $t('AUTOMATION.OPERATIONS.CADENCES.BACKFILL_TITLE') }}
        </span>
        <WootLabel label="dry-run" color="teal" compact />
        <WootLabel
          :label="backfillPreview.writes ? 'writes' : 'writes=false'"
          :color="backfillPreview.writes ? 'ruby' : 'teal'"
          compact
        />
      </div>
      <div class="flex flex-wrap gap-x-4 gap-y-1 text-body-main">
        <span class="tabular-nums text-n-slate-12">
          {{
            $t('AUTOMATION.OPERATIONS.CADENCES.READY', {
              count: backfillPreview.summary?.ready_count || 0,
            })
          }}
        </span>
        <span class="tabular-nums text-n-slate-11">
          {{
            $t('AUTOMATION.OPERATIONS.CADENCES.DRIFT', {
              count: backfillPreview.summary?.drift_count || 0,
            })
          }}
        </span>
        <span class="tabular-nums text-n-slate-11">
          {{
            $t('AUTOMATION.OPERATIONS.CADENCES.BLOCKED', {
              count: backfillPreview.summary?.blocked_count || 0,
            })
          }}
        </span>
      </div>
    </div>

    <div
      v-if="cutoverPreview"
      class="min-w-0 border border-n-weak bg-n-surface-1 p-3"
      data-test="cadence-cutover-preview"
    >
      <div class="mb-2 flex flex-wrap items-center gap-2">
        <span class="text-label-large text-n-slate-12">
          {{ $t('AUTOMATION.OPERATIONS.CADENCES.CUTOVER_TITLE') }}
        </span>
        <WootLabel
          :label="formatStatus(cutoverPreview.decision)"
          :color="labelColor(cutoverPreview.decision)"
          compact
        />
        <WootLabel label="dry-run" color="teal" compact />
      </div>
      <div class="flex flex-wrap gap-x-4 gap-y-1 text-body-main">
        <span class="tabular-nums text-n-slate-12">
          {{
            $t('AUTOMATION.OPERATIONS.CADENCES.CYCLES', {
              count: cutoverPreview.summary?.cycle_count || 0,
            })
          }}
        </span>
        <span class="tabular-nums text-n-slate-11">
          {{
            $t('AUTOMATION.OPERATIONS.CADENCES.ISSUES', {
              count: cutoverPreview.issues?.length || 0,
            })
          }}
        </span>
        <span class="tabular-nums text-n-slate-11">
          {{
            $t('AUTOMATION.OPERATIONS.CADENCES.OLD_VERSION', {
              count:
                cutoverPreview.version_cutover?.reduce(
                  (total, item) =>
                    total + Number(item.old_version_active_count || 0),
                  0
                ) || 0,
            })
          }}
        </span>
      </div>
    </div>
  </div>
</template>
